import _ from 'lodash'
import { REQUEST } from 'crom-api-constants'

export const OPEN_BLOCK = 'OPEN_BLOCK'
export const CLOSE_BLOCK = 'CLOSE_BLOCK'
export const TOGGLE_BLOCK = 'TOGGLE_BLOCK'

export const SAVE_CUSTOM_BLOCK_DATA = 'SAVE_CUSTOM_BLOCK_DATA'

export const LOAD_BLOCK_DATA = 'LOAD_BLOCK_DATA'
export const BLOCK_DATA_REQUEST = (module, id, blockKey, namespace) =>
    `LOAD_BLOCK_${_.toUpper(module)}_${_.toUpper(id)}_${_.toUpper(blockKey)}_${_.toUpper(namespace)}_DATA_${REQUEST}`
export const BLOCK_DATA_START_LOADING = 'BLOCK_DATA_START_LOADING'
export const BLOCK_DATA_LOADED = 'BLOCK_DATA_LOADED'
export const BLOCK_DATA_EMPTY = 'BLOCK_DATA_EMPTY'
export const BLOCK_DATA_LOAD_FAILED = 'BLOCK_DATA_LOAD_FAILED'
export const BLOCK_DATA_TRANSFORMED = 'BLOCK_DATA_TRANSFORMED'

export const SAVE_IS_SCROLLED = 'SAVE_IS_SCROLLED'
